import React from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {BsChevronDown} from "react-icons/bs";
import {useGroupManager} from "../../Providers/groupManager";
import {getCampaigns} from "../../../Services/campaignFunctions";
import {Container, Trigger, Menu, Item, ItemName, Message} from "./styles";

/**
 * Seletor de campanha do header: dropdown que lista todas as campanhas do
 * usuário e navega para a campanha escolhida (/campaign/:id/manager).
 * Busca a lista de forma preguiçosa (só na 1ª abertura) e fecha ao clicar fora.
 * A campanha atual vem do GroupManagerProvider (não usa useParams).
 */
const CampaignSwitcher = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const {campaign, loading} = useGroupManager();
    const ref = React.useRef(null);
    const fetchingRef = React.useRef(false);
    const [open, setOpen] = React.useState(false);
    const [campaigns, setCampaigns] = React.useState([]);
    const [fetched, setFetched] = React.useState(false);
    const [loadingList, setLoadingList] = React.useState(false);

    // Fecha ao clicar fora do componente.
    React.useEffect(() => {
        const onClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    const toggle = async () => {
        const next = !open;
        setOpen(next);
        if (next && !fetched && !fetchingRef.current) {
            fetchingRef.current = true;
            setLoadingList(true);
            const list = await getCampaigns();
            setCampaigns(Array.isArray(list) ? list : []);
            setFetched(true);
            setLoadingList(false);
            fetchingRef.current = false;
        }
    };

    const select = (item) => {
        setOpen(false);
        if (item.id === campaign?.id) return; // no-op na campanha atual
        history.push(`/campaign/${item.id}/manager`);
    };

    const triggerLabel = loading ? "…" : (campaign?.name || "—");

    return (
        <Container ref={ref}>
            <Trigger type="button" onClick={toggle}>
                <span>{triggerLabel}</span>
                <BsChevronDown/>
            </Trigger>

            {open && (
                <Menu>
                    {loadingList && <Message>{t("words.loading")}</Message>}
                    {!loadingList && campaigns.length === 0 && (
                        <Message>{t("words.no_campaigns")}</Message>
                    )}
                    {!loadingList && campaigns.map((item) => (
                        <Item
                            key={item.id}
                            type="button"
                            $active={item.id === campaign?.id}
                            onClick={() => select(item)}
                        >
                            <ItemName>{item.name}</ItemName>
                        </Item>
                    ))}
                </Menu>
            )}
        </Container>
    );
};

export default CampaignSwitcher;
